import { connect } from "react-redux";
import { getListQuanLyThuChiNgoaiLe } from "../../actions/QuanLyThuChiNgoaiLe";
import { QuanLyThuChiNgoaiLe } from "components/QuanLyThuChi/ThuChiNgoaiLe";

const mapStateToProps = (state) => ({
  QuanLyThuChiNgoaiLe: state.QuanLyThuChiNgoaiLe,
});

const mapDispatchToProps = (dispatch) => ({
  getListQuanLyThuChiNgoaiLe: (dataSearch) =>
    dispatch(getListQuanLyThuChiNgoaiLe(dataSearch)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuanLyThuChiNgoaiLe);
